import './checkbox.css';

export const Checkbox = ({ checked = false, onChange }) => {
    return (
        <div className="checkbox">
            <input className={checked ? 'checked' : ''} type="checkbox" checked={checked} onChange={onChange} />
        </div>
    );
};
